import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import Loader from '../ui/Loader';
import {SESSION_RELOGIN_MESSAGE} from "../../constants/sessionStateTypes";

class LoginForm extends Component {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(e) {
    e.preventDefault();
    this.props.onSubmit(this.usernameTextInput.value, this.passwordTextInput.value);
  }

  render() {
    let isDisabled = false;
    let loginButtonText = 'Login';
    if (this.props.isLoading) {
      isDisabled = true;
      loginButtonText = <Loader />;
    }

    return (
      <div className="login__form">
        <div className="login__logo">&nbsp;</div>
        <h2 className="login__tag">Welcome to Piction.
          <span className="login__tag--strong"> Please Log in.</span>
        </h2>
        <form className="form" onSubmit={this.onSubmit}>
          <fieldset disabled={isDisabled}>
            <input
              type="text"
              className="form__field"
              ref={(ref) => { this.usernameTextInput = ref; }}
              placeholder="Username"
            />
            <input
              type="password"
              className="form__field form__field--pass"
              ref={(ref) => { this.passwordTextInput = ref; }}
              placeholder="Password"
            />
            <div className="form__notification">
              { this.props.sessionStateMessage.includes(SESSION_RELOGIN_MESSAGE) ?
                <FormattedMessage id='general.reLogin' />
              : this.props.sessionStateMessage
              }
            </div>
            <button className="btn btn-primary" type="submit">{loginButtonText}</button>
          </fieldset>
        </form>
      </div>
    );
  }
}

LoginForm.propTypes = {
  onSubmit: PropTypes.func,
  isLoading: PropTypes.bool,
  sessionStateMessage: PropTypes.string,
};

export default injectIntl(LoginForm);



// WEBPACK FOOTER //
// ./src/js/components/Login/LoginForm.jsx